class StickyAtcBar extends HTMLElement {
  constructor() {
    super();
    this.visibleClass = "sticky-atc-bar--visible";
    this.observer = null;
  }

  connectedCallback() {
    this.button = this.querySelector("[data-sticky-atc-button]");
    this.target = this.getTarget();
    this.onTriggerClick = this.onTriggerClick.bind(this);

    if (this.button) {
      this.button.addEventListener("click", this.onTriggerClick);
    }

    this.observeTarget();
  }

  disconnectedCallback() {
    if (this.button) {
      this.button.removeEventListener("click", this.onTriggerClick);
    }

    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }

  getTarget() {
    return document.getElementById("BUY");
  }

  getVisibilityTarget() {
    return (
      document.querySelector(".wt-featured-product") ||
      document.querySelector(".section-featured-product") ||
      this.getTarget()
    );
  }

  onTriggerClick(event) {
    if (!this.target) {
      this.target = this.getTarget();
    }

    if (!this.target) return;

    event.preventDefault();
    this.scrollTargetToCenter();
    this.setHash();
  }

  setHash() {
    const href = this.button && this.button.getAttribute("href");
    if (!href || href.charAt(0) !== "#") return;

    const url = `${window.location.pathname}${window.location.search}${href}`;
    if (`${window.location.pathname}${window.location.search}${window.location.hash}` === url) {
      return;
    }

    if (history.pushState) {
      history.pushState(null, "", url);
    }
  }

  getScrollPosition() {
    if (window.lenis && typeof window.lenis.scroll === "number") {
      return window.lenis.scroll;
    }

    return window.scrollY || document.documentElement.scrollTop || 0;
  }

  scrollTargetToCenter() {
    const rect = this.target.getBoundingClientRect();
    const mobileOffset = window.matchMedia("(max-width: 899px)").matches ? 100 : 0;
    const top = this.getScrollPosition() + rect.top + mobileOffset;

    if (window.lenis && typeof window.lenis.scrollTo === "function") {
      window.lenis.scrollTo(top);
      return;
    }

    window.scrollTo({ top, behavior: "smooth" });
  }

  observeTarget() {
    if (window.Shopify && window.Shopify.designMode) {
      this.classList.add(this.visibleClass);
      return;
    }

    const visibilityTarget = this.getVisibilityTarget();

    if (!visibilityTarget || this.dataset.hideWhenTargetVisible !== "true") {
      this.classList.add(this.visibleClass);
      return;
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        if (!entry) return;

        if (entry.isIntersecting) {
          this.classList.remove(this.visibleClass);
        } else {
          this.classList.add(this.visibleClass);
        }
      },
      { threshold: 0.12, rootMargin: "0px" }
    );

    this.observer.observe(visibilityTarget);
  }
}

customElements.define("sticky-atc-bar", StickyAtcBar);
